import docCookies from 'doc-cookies';
import { load } from 'recaptcha-v3';
import { BASE_URL_SANCTUM, RECAPTCHA_SITE_KEY } from '../misc/consts';

export default () => ({
  form: null,
  sent: false,
  sending: false,

  init() {
    this.form = this.$el;
  },

  get action() {
    return this.form.action;
  },

  async getXsfrToken() {
    const response = await fetch(BASE_URL_SANCTUM);
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
  },

  resetForm() {
    this.form.reset();
  },

  isValid() {
    return this.form.reportValidity();
  },

  async getRecaptchaToken(action) {
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    return await recaptcha.execute(action);
  },

  buttonText(text) {
    return this.sent ? 'Odesláno' : text;
  },

  async send() {
    if (!this.isValid()) {
      return false;
    }
    this.sending = true;
    await this.getXsfrToken();

    const data = new URLSearchParams(new FormData(this.form));

    const recaptchaAction = this.action.replace(/[^A-Za-z]/g, '');
    const token = await this.getRecaptchaToken(recaptchaAction);

    data.append('recaptcha_token', token);
    data.append('recaptcha_action', recaptchaAction);
    data.delete('_token');

    fetch(this.action, {
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    }).then((response) => {
      if (response.ok) {
        this.sent = true;
        setTimeout(() => {
          this.resetForm();
          this.sending = false;
          this.$dispatch('select:reset');
          const conversionConf = { id: 100194475, value: null };
          if (window.rc && window.rc.conversionHit) {
            window.rc.conversionHit(conversionConf);
          }

          if(window.gtag_report_conversion) {
            const url = window.location.href;
            window.gtag_report_conversion(url);
          }
        }, 500);
      }
    });
  },
});
